import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { ThemeProvider } from './components/theme.js';
import { TooltipProvider } from './components/ui/tooltip.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('elemento #root não encontrado');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <TooltipProvider delayDuration={300}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  </StrictMode>,
);
